export const formatSvg = svg => {
    // 过滤 display-p3样式
    let code = svg.replace(/fill:color\(display-p3.*?\)/g, '');
    code = code.replace(/stroke:color\(display-p3.*?\)/g, '');
    return code;
}